function InviteIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.188 10.313c0-.45.045-.89.132-1.313H8.625A2.628 2.628 0 006 11.625V19.5a2.628 2.628 0 002.625 2.625v3.281a.656.656 0 001.083.499l4.41-3.78h6.32a2.628 2.628 0 002.625-2.625v-2.758a6.563 6.563 0 01-7.875-6.43z" />
      <path d="M21.75 5.063a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm1.969 5.906h-1.313v1.312a.656.656 0 01-1.312 0V10.97H19.78a.657.657 0 010-1.313h1.313V8.344a.656.656 0 011.312 0v1.312h1.313a.656.656 0 010 1.313z" />
    </svg>
  )
}

export default InviteIcon
